import { CreditCard, Spinner } from "@phosphor-icons/react";
import useCard from "../hooks/useCard";
import useInitializeAddCard, {
  getAddCardAuthorizationUrl,
} from "../hooks/useInitializeAddCard";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const LinkedCard = () => {
  const { card, isLoading, isError, isRefetching, error } = useCard();

  const { initializing, initializeAddCard } = useInitializeAddCard({
    onError(error) {
      toast.error(error.message);
    },
    onSuccess(data) {
      const authorizationUrl = getAddCardAuthorizationUrl(data);

      if (authorizationUrl) {
        toast.success("Redirecting to secure card authorization...");
        window.location.assign(authorizationUrl);
        return;
      }

      toast.error("We couldn't start card linking. Please try again.");
    },
  });

  return (
    <>
      <div className="bg-white drop-shadow rounded-xl p-5 w-full flex gap-5 items-center justify-between">
        <div className="flex gap-5 items-center">
          <div className="rounded-full bg-visaro-orange/10 p-2 text-visaro-orange">
            <CreditCard size={24} />
          </div>
          <div className="flex flex-col items-start text-left">
            <div className="font-medium">Your Card</div>
            {card && card?.data ? (
              <div
                style={{
                  textTransform: "capitalize",
                  opacity: 0.8,
                }}
              >
                {card?.data?.card_type} ****
                {card?.data?.last_four_digit}
              </div>
            ) : (
              <div
                style={{
                  opacity: 0.8,
                }}
              >
                {isLoading || isRefetching
                  ? "Loading..."
                  : isError && error?.message}
              </div>
            )}
          </div>
        </div>
        {card && card?.data ? (
          <Link to="/wallet">
            <div className="p-2 bg-gray-100 hover:bg-gray-200 transition px-6 rounded-full text-sm font-medium">
              View
            </div>
          </Link>
        ) : (
          <button
            type="button"
            disabled={initializing}
            onClick={() => {
              initializeAddCard({});
            }}
            style={{
              borderRadius: 20,
            }}
          >
            {initializing ? (
              <Spinner className="animate-spin" />
            ) : (
              <div className="p-2 bg-gray-100 hover:bg-gray-200 transition px-6 rounded-full text-sm font-medium">
                Link
              </div>
            )}
          </button>
        )}
      </div>
    </>
  );
};

export default LinkedCard;
